/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPGOAL } from './IAPGOAL';
import {
    IAPGOALFromJSON,
    IAPGOALFromJSONTyped,
    IAPGOALToJSON,
} from './IAPGOAL';
import type { IAPNEED } from './IAPNEED';
import {
    IAPNEEDFromJSON,
    IAPNEEDFromJSONTyped,
    IAPNEEDToJSON,
} from './IAPNEED';
import type { IAPPRODUCTCODE } from './IAPPRODUCTCODE';
import {
    IAPPRODUCTCODEFromJSON,
    IAPPRODUCTCODEFromJSONTyped,
    IAPPRODUCTCODEToJSON,
} from './IAPPRODUCTCODE';
import type { IAPPRODUCTCONFIGURATIONCODE } from './IAPPRODUCTCONFIGURATIONCODE';
import {
    IAPPRODUCTCONFIGURATIONCODEFromJSON,
    IAPPRODUCTCONFIGURATIONCODEFromJSONTyped,
    IAPPRODUCTCONFIGURATIONCODEToJSON,
} from './IAPPRODUCTCONFIGURATIONCODE';
import type { IAPPRODUCTTYPE } from './IAPPRODUCTTYPE';
import {
    IAPPRODUCTTYPEFromJSON,
    IAPPRODUCTTYPEFromJSONTyped,
    IAPPRODUCTTYPEToJSON,
} from './IAPPRODUCTTYPE';
import type { IAPTYPEOFMONEY } from './IAPTYPEOFMONEY';
import {
    IAPTYPEOFMONEYFromJSON,
    IAPTYPEOFMONEYFromJSONTyped,
    IAPTYPEOFMONEYToJSON,
} from './IAPTYPEOFMONEY';
import type { ProductCustomRule } from './ProductCustomRule';
import {
    ProductCustomRuleFromJSON,
    ProductCustomRuleFromJSONTyped,
    ProductCustomRuleToJSON,
} from './ProductCustomRule';

/**
 * 
 * @export
 * @interface ProductOptionViewModel
 */
export interface ProductOptionViewModel {
    /**
     * 
     * @type {IAPPRODUCTCONFIGURATIONCODE}
     * @memberof ProductOptionViewModel
     */
    productConfigurationCode: IAPPRODUCTCONFIGURATIONCODE;
    /**
     * 
     * @type {IAPPRODUCTCODE}
     * @memberof ProductOptionViewModel
     */
    productCode: IAPPRODUCTCODE;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    productCodeId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    productConfigurationId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductOptionViewModel
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductOptionViewModel
     */
    productVariationDescription: string;
    /**
     * 
     * @type {string}
     * @memberof ProductOptionViewModel
     */
    productVariationExtendedDescription: string;
    /**
     * 
     * @type {Array<IAPPRODUCTTYPE>}
     * @memberof ProductOptionViewModel
     */
    productTypes: Array<IAPPRODUCTTYPE>;
    /**
     * 
     * @type {Array<IAPTYPEOFMONEY>}
     * @memberof ProductOptionViewModel
     */
    typeOfMoneys: Array<IAPTYPEOFMONEY>;
    /**
     * 
     * @type {Array<IAPGOAL>}
     * @memberof ProductOptionViewModel
     */
    goals: Array<IAPGOAL>;
    /**
     * 
     * @type {Array<IAPNEED>}
     * @memberof ProductOptionViewModel
     */
    needs: Array<IAPNEED>;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    onceOffInvestmentAmountMinimum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    onceOffInvestmentAmountMaximum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    transferInAmountMinimum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    transferInAmountMaximum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    recurringContributionMonthlyMinimum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    recurringContributionMonthlyMaximum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    recurringContributionQuarterlyMinimum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    recurringContributionQuarterlyMaximum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    recurringContributionBiAnnualMinimum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    recurringContributionBiAnnualMaximum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    recurringContributionYearlyMinimum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    recurringContributionYearlyMaximum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    initialAdviceFeeMinimum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    initialAdviceFeeMaximum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    annualAdviceFeeMinimum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    annualAdviceFeeMaximum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    recurringWithdrawalAdviceFeePercentageMinimum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    recurringWithdrawalAdviceFeePercentageMaximum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    annualIncomePercentageMinimum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    annualIncomePercentageMaximum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    maxFundSelection?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    incomeTaxPercentageMinimum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    incomeTaxPercentageMaximum?: number;
    /**
     * 
     * @type {Array<ProductCustomRule>}
     * @memberof ProductOptionViewModel
     */
    customRule?: Array<ProductCustomRule>;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    growthRatePercentageMinimum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    growthRatePercentageMaximum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    justPortfolioInvestmentAmountMinimum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionViewModel
     */
    justPortfolioInvestmentAmountMaximum?: number;
}

/**
 * Check if a given object implements the ProductOptionViewModel interface.
 */
export function instanceOfProductOptionViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "productConfigurationCode" in value;
    isInstance = isInstance && "productCode" in value;
    isInstance = isInstance && "productName" in value;
    isInstance = isInstance && "productVariationDescription" in value;
    isInstance = isInstance && "productVariationExtendedDescription" in value;
    isInstance = isInstance && "productTypes" in value;
    isInstance = isInstance && "typeOfMoneys" in value;
    isInstance = isInstance && "goals" in value;
    isInstance = isInstance && "needs" in value;

    return isInstance;
}

export function ProductOptionViewModelFromJSON(json: any): ProductOptionViewModel {
    return ProductOptionViewModelFromJSONTyped(json, false);
}

export function ProductOptionViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductOptionViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productConfigurationCode': IAPPRODUCTCONFIGURATIONCODEFromJSON(json['ProductConfigurationCode']),
        'productCode': IAPPRODUCTCODEFromJSON(json['ProductCode']),
        'productCodeId': !exists(json, 'ProductCodeId') ? undefined : json['ProductCodeId'],
        'productConfigurationId': !exists(json, 'ProductConfigurationId') ? undefined : json['ProductConfigurationId'],
        'productName': json['ProductName'],
        'productVariationDescription': json['ProductVariationDescription'],
        'productVariationExtendedDescription': json['ProductVariationExtendedDescription'],
        'productTypes': ((json['ProductTypes'] as Array<any>).map(IAPPRODUCTTYPEFromJSON)),
        'typeOfMoneys': ((json['TypeOfMoneys'] as Array<any>).map(IAPTYPEOFMONEYFromJSON)),
        'goals': ((json['Goals'] as Array<any>).map(IAPGOALFromJSON)),
        'needs': ((json['Needs'] as Array<any>).map(IAPNEEDFromJSON)),
        'onceOffInvestmentAmountMinimum': !exists(json, 'OnceOffInvestmentAmountMinimum') ? undefined : json['OnceOffInvestmentAmountMinimum'],
        'onceOffInvestmentAmountMaximum': !exists(json, 'OnceOffInvestmentAmountMaximum') ? undefined : json['OnceOffInvestmentAmountMaximum'],
        'transferInAmountMinimum': !exists(json, 'TransferInAmountMinimum') ? undefined : json['TransferInAmountMinimum'],
        'transferInAmountMaximum': !exists(json, 'TransferInAmountMaximum') ? undefined : json['TransferInAmountMaximum'],
        'recurringContributionMonthlyMinimum': !exists(json, 'RecurringContributionMonthlyMinimum') ? undefined : json['RecurringContributionMonthlyMinimum'],
        'recurringContributionMonthlyMaximum': !exists(json, 'RecurringContributionMonthlyMaximum') ? undefined : json['RecurringContributionMonthlyMaximum'],
        'recurringContributionQuarterlyMinimum': !exists(json, 'RecurringContributionQuarterlyMinimum') ? undefined : json['RecurringContributionQuarterlyMinimum'],
        'recurringContributionQuarterlyMaximum': !exists(json, 'RecurringContributionQuarterlyMaximum') ? undefined : json['RecurringContributionQuarterlyMaximum'],
        'recurringContributionBiAnnualMinimum': !exists(json, 'RecurringContributionBiAnnualMinimum') ? undefined : json['RecurringContributionBiAnnualMinimum'],
        'recurringContributionBiAnnualMaximum': !exists(json, 'RecurringContributionBiAnnualMaximum') ? undefined : json['RecurringContributionBiAnnualMaximum'],
        'recurringContributionYearlyMinimum': !exists(json, 'RecurringContributionYearlyMinimum') ? undefined : json['RecurringContributionYearlyMinimum'],
        'recurringContributionYearlyMaximum': !exists(json, 'RecurringContributionYearlyMaximum') ? undefined : json['RecurringContributionYearlyMaximum'],
        'initialAdviceFeeMinimum': !exists(json, 'InitialAdviceFeeMinimum') ? undefined : json['InitialAdviceFeeMinimum'],
        'initialAdviceFeeMaximum': !exists(json, 'InitialAdviceFeeMaximum') ? undefined : json['InitialAdviceFeeMaximum'],
        'annualAdviceFeeMinimum': !exists(json, 'AnnualAdviceFeeMinimum') ? undefined : json['AnnualAdviceFeeMinimum'],
        'annualAdviceFeeMaximum': !exists(json, 'AnnualAdviceFeeMaximum') ? undefined : json['AnnualAdviceFeeMaximum'],
        'recurringWithdrawalAdviceFeePercentageMinimum': !exists(json, 'RecurringWithdrawalAdviceFeePercentageMinimum') ? undefined : json['RecurringWithdrawalAdviceFeePercentageMinimum'],
        'recurringWithdrawalAdviceFeePercentageMaximum': !exists(json, 'RecurringWithdrawalAdviceFeePercentageMaximum') ? undefined : json['RecurringWithdrawalAdviceFeePercentageMaximum'],
        'annualIncomePercentageMinimum': !exists(json, 'AnnualIncomePercentageMinimum') ? undefined : json['AnnualIncomePercentageMinimum'],
        'annualIncomePercentageMaximum': !exists(json, 'AnnualIncomePercentageMaximum') ? undefined : json['AnnualIncomePercentageMaximum'],
        'maxFundSelection': !exists(json, 'MaxFundSelection') ? undefined : json['MaxFundSelection'],
        'incomeTaxPercentageMinimum': !exists(json, 'IncomeTaxPercentageMinimum') ? undefined : json['IncomeTaxPercentageMinimum'],
        'incomeTaxPercentageMaximum': !exists(json, 'IncomeTaxPercentageMaximum') ? undefined : json['IncomeTaxPercentageMaximum'],
        'customRule': !exists(json, 'CustomRule') ? undefined : ((json['CustomRule'] as Array<any>).map(ProductCustomRuleFromJSON)),
        'growthRatePercentageMinimum': !exists(json, 'GrowthRatePercentageMinimum') ? undefined : json['GrowthRatePercentageMinimum'],
        'growthRatePercentageMaximum': !exists(json, 'GrowthRatePercentageMaximum') ? undefined : json['GrowthRatePercentageMaximum'],
        'justPortfolioInvestmentAmountMinimum': !exists(json, 'JustPortfolioInvestmentAmountMinimum') ? undefined : json['JustPortfolioInvestmentAmountMinimum'],
        'justPortfolioInvestmentAmountMaximum': !exists(json, 'JustPortfolioInvestmentAmountMaximum') ? undefined : json['JustPortfolioInvestmentAmountMaximum'],
    };
}

export function ProductOptionViewModelToJSON(value?: ProductOptionViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProductConfigurationCode': IAPPRODUCTCONFIGURATIONCODEToJSON(value.productConfigurationCode),
        'ProductCode': IAPPRODUCTCODEToJSON(value.productCode),
        'ProductCodeId': value.productCodeId,
        'ProductConfigurationId': value.productConfigurationId,
        'ProductName': value.productName,
        'ProductVariationDescription': value.productVariationDescription,
        'ProductVariationExtendedDescription': value.productVariationExtendedDescription,
        'ProductTypes': ((value.productTypes as Array<any>).map(IAPPRODUCTTYPEToJSON)),
        'TypeOfMoneys': ((value.typeOfMoneys as Array<any>).map(IAPTYPEOFMONEYToJSON)),
        'Goals': ((value.goals as Array<any>).map(IAPGOALToJSON)),
        'Needs': ((value.needs as Array<any>).map(IAPNEEDToJSON)),
        'OnceOffInvestmentAmountMinimum': value.onceOffInvestmentAmountMinimum,
        'OnceOffInvestmentAmountMaximum': value.onceOffInvestmentAmountMaximum,
        'TransferInAmountMinimum': value.transferInAmountMinimum,
        'TransferInAmountMaximum': value.transferInAmountMaximum,
        'RecurringContributionMonthlyMinimum': value.recurringContributionMonthlyMinimum,
        'RecurringContributionMonthlyMaximum': value.recurringContributionMonthlyMaximum,
        'RecurringContributionQuarterlyMinimum': value.recurringContributionQuarterlyMinimum,
        'RecurringContributionQuarterlyMaximum': value.recurringContributionQuarterlyMaximum,
        'RecurringContributionBiAnnualMinimum': value.recurringContributionBiAnnualMinimum,
        'RecurringContributionBiAnnualMaximum': value.recurringContributionBiAnnualMaximum,
        'RecurringContributionYearlyMinimum': value.recurringContributionYearlyMinimum,
        'RecurringContributionYearlyMaximum': value.recurringContributionYearlyMaximum,
        'InitialAdviceFeeMinimum': value.initialAdviceFeeMinimum,
        'InitialAdviceFeeMaximum': value.initialAdviceFeeMaximum,
        'AnnualAdviceFeeMinimum': value.annualAdviceFeeMinimum,
        'AnnualAdviceFeeMaximum': value.annualAdviceFeeMaximum,
        'RecurringWithdrawalAdviceFeePercentageMinimum': value.recurringWithdrawalAdviceFeePercentageMinimum,
        'RecurringWithdrawalAdviceFeePercentageMaximum': value.recurringWithdrawalAdviceFeePercentageMaximum,
        'AnnualIncomePercentageMinimum': value.annualIncomePercentageMinimum,
        'AnnualIncomePercentageMaximum': value.annualIncomePercentageMaximum,
        'MaxFundSelection': value.maxFundSelection,
        'IncomeTaxPercentageMinimum': value.incomeTaxPercentageMinimum,
        'IncomeTaxPercentageMaximum': value.incomeTaxPercentageMaximum,
        'CustomRule': value.customRule === undefined ? undefined : ((value.customRule as Array<any>).map(ProductCustomRuleToJSON)),
        'GrowthRatePercentageMinimum': value.growthRatePercentageMinimum,
        'GrowthRatePercentageMaximum': value.growthRatePercentageMaximum,
        'JustPortfolioInvestmentAmountMinimum': value.justPortfolioInvestmentAmountMinimum,
        'JustPortfolioInvestmentAmountMaximum': value.justPortfolioInvestmentAmountMaximum,
    };
}

